import { getItem } from '../localStorage';
import getDiffInSeconds from '../getDiffInSeconds';
import { computeActiveFilters } from './index';

export const proposeValidByTimestamp = (proposeObj) => {
  if (!proposeObj.propose) {
    // console.log('propose già false');
    return proposeObj;
  }
  const last = getItem('proposeSaveSearchTime');
  if (!last) {
    // console.log('non esiste il record');
    return proposeObj;
  }
  const lastTime = getDiffInSeconds(last);

  if (lastTime > 300) {
    // console.log('è passata 5 minuti');
    return proposeObj;
  }

  // console.log('son passati meno di 5 minuti');
  return {
    propose: false,
    reason: 'No-AlreadyOpenedInLessThan30Minutes',
  };
};

function proposeSaveSearchAfterLead({
  userHasNoBookmarks = true,
  userBookmarkedL6 = [],
  adProvince = '',
  srpTotalResults = 0,
  activeNearby,
  filters,
  locations,
}) {
  const { activeFiltersCount } = computeActiveFilters(filters);
  const isMapSearch = locations.length && locations[0].level === 999;
  const isZoneSearch = locations.length && locations[0].level > 9;
  const hasBookmarksInProvince = userBookmarkedL6.includes(adProvince);

  const result = {};

  if (
    // l'utente non ha ricerche salvate o nessuna delle sue ricerche salvate
    // è all'interno della provincia dell'annuncio
    (userHasNoBookmarks || !hasBookmarksInProvince)
    && srpTotalResults > 10 // la ricerca corrente ha più di 10 risultati
    && (
      activeFiltersCount > 1 // c'è più di un filtro attivo
      || srpTotalResults < 500 // la ricerca di provenienza conta meno di 300 annunci
      || activeNearby // è una ricerca per nearby
      || isMapSearch // è una ricerca su mappa
      || isZoneSearch // c'è almeno una località di tipo zona/quartiere selezionata
    )
  ) {
    result.propose = true;
  } else {
    result.propose = false;
    if (hasBookmarksInProvince) {
      result.reason = 'No-HasSavedSearches';
    } else if (srpTotalResults < 10) {
      result.reason = 'No-FewResults';
    } else {
      result.reason = 'No-TooMuchResults';
    }
  }

  return result;
}

export default proposeSaveSearchAfterLead;
